<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="document_template_list" :search="search"
                class="elevation-1 mytable" dense>
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Document Template Type</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px"></span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="1" cols="12"></v-col>
                        <v-col sm="6" md="4" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Document Template Type</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.name" :rules="[
                              (v) => !!v || 'Name is required',
                              (v) => (v && v.length <= 50) || 'Name must be less than 50 characters'
                            ]" label="Document Template Type" persistent-hint></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-checkbox v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-icon class="edit-v-icon mr-1" size="26" color="primary" @click="editItem(item)">edit</v-icon>
                        <v-icon class="mr-2" size="25" @click="deleteItem(item)" color="error">mdi-delete</v-icon>
                    </div>
                </template>
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        data: () => ({
            valid: false,
            overlay: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            headers: [
                {
                    text: "Name",
                    align: "left",
                    sortable: false,
                    value: "name",
                },
                {
                    text: "Active",
                    align: "left",
                    sortable: true,
                    value: "isactive",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            document_template_list: [],
            editedIndex: -1,
            editedItem: {
                id: null,
                name: "",
                isactive: true,
            },
            defaultItem: {
                id: null,
                name: "",
                isactive: true,
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Document Template Type" : "Edit Document Template Type";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
        },

        mounted() {
            this.onLoad();
        },

        methods: {
            onLoad() {
                this.overlay = true;
                axios
                    .get("/ Examination/getDocumentTemplateType")
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.document_template_list) {
                            this.document_template_list = res.data.document_template_list;
                        } else if (res.data.msg && (res.data.msg === "401" || res.data.msg === "403")) {
                            this.showSnackbar("#b71c1c", "Unauthorized access");
                        } else if (res.data.msg === "404") {
                            this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
                        } else {
                            this.showSnackbar("#b71c1c", "Failed to load Document Template Types");
                        }
                    })
                    .catch((error) => {
                        this.overlay = false;
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        console.error(error);
                    });
            },

            editItem(item) {
                this.editedIndex = this.document_template_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            deleteItem(item) {
                if (!confirm(`Are you sure you want to delete Document Template Type '${item.name}'?`)) return;
                axios
                    .post("/Examination/deleteDocumentTemplateType", { deleteid: item.id, name: item.name })
                    .then((res) => {
                        if (res.data.status && res.data.status.code === "SUCCESS") {
                            this.showSnackbar("#4caf50", "Document Template Type Deleted Successfully");
                            this.onLoad();
                        } else {
                            this.showSnackbar(
                                "#b71c1c",
                                res.data.status ? res.data.status.message : "Failed to delete Document Template Type"
                            );
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                        console.error(error);
                    });
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },

            save() {
                if (!this.editedItem.name || this.editedItem.name.trim() === "") {
                    this.showSnackbar("#b71c1c", "DocumentTemplateType is required.");
                    return;
                }


                const payload = {
                    name: this.editedItem.name.trim(),
                    isactive: this.editedItem.isactive,
                };

                if (this.editedIndex > -1) {
                    // Edit
                    payload.editid = this.editedItem.id;
                    axios
                        .post("/Examination/editDocumentTemplateType", payload)
                        .then((res) => {
                            if (res.data.status && res.data.status.code === "SUCCESS") {
                                Object.assign(this.document_template_list[this.editedIndex], this.editedItem);
                                this.showSnackbar("#4caf50", "Document Template Type Updated Successfully");
                            } else if (res.data.status && res.data.status.code === "NA") {
                                this.showSnackbar("#b71c1c", res.data.status.message);
                            } else if (res.data.msg === "404") {
                                this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
                            } else {
                                this.showSnackbar("#b71c1c", "Failed to update Document Template Type");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            console.error(error);
                        });
                } else {
                    // Save new
                    axios
                        .post("/ Examination/saveDocumentTemplateType", payload)
                        .then((res) => {
                            if (res.data.status && res.data.status.code === "SUCCESS") {
                                this.showSnackbar("#4caf50", "Document Template Type Added Successfully");
                                this.onLoad();
                            } else if (res.data.status && res.data.status.code === "NA") {
                                this.showSnackbar("#b71c1c", res.data.status.message);
                            } else if (res.data.msg === "404") {
                                this.showSnackbar("#b71c1c", res.data.snackbar || "User not found");
                            } else {
                                this.showSnackbar("#b71c1c", "Failed to add Document Template Type");
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                            console.error(error);
                        });
                }
                this.close();
            },
        },
    };
</script>

<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
</style>